import { LexCusTypeAcces}  from './gen-lexs';
import AbstractModel, { Model } from './abstract-model';

@Model('CavCusAccesContactAdresse')
export default class CavCusAccesContactAdresse extends AbstractModel {
  public id: number = null;
  public idCavite: string = null;
  public typeAcces: LexCusTypeAcces = null;
  public natureAcces: string = null;
  public contact: string = null;
  public nom: string = null;
  public adresse: string = null;
  public telephone: string = null;
  public fax: string = null;
}

